<template>
  <b-button variant="outline-primary" @click="handleClick">
    {{ 0 === activeStep ? 'Cancel' : 'Back' }}
  </b-button>
</template>

<script>
import { defineComponent, inject } from '@vue/composition-api'

export default defineComponent({
  name: 'BDXWizardBackButton',
  emits: ['cancel'],
  setup(_, { emit }) {
    const { activeStep, setActiveStep } = inject('bdx-wizard--steps')

    const handleClick = () => {
      if (0 === activeStep.value) {
        emit('cancel')
      } else {
        const newActiveStep = activeStep.value - 1

        setActiveStep(newActiveStep)
      }
    }

    return {
      activeStep,

      handleClick
    }
  }
})
</script>
